module.exports = __webpack_public_path__ + "img/capability-blockchain.76228aa7.png";